// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

export const environment = {
  production: false,
  pendoEnabled: false,
  batchSdnCalls: process.env['NX_PUBLIC_BATCH_SDN_CALLS'] !== '0',
  appVersion: process.env['NX_PUBLIC_APP_VERSION'],
  appEnv: process.env['NX_PUBLIC_APP_ENV'],
  powerTabsSfID: 'a56TI000000PJM1YAO',
  agentforceOrgId: '00DcX000004xoCz',
  agentforceDeploymentName: 'External_Messaging',
  agentforceSiteUrl: 'https://spins--uat.sandbox.my.site.com/ESWExternalMessaging1779744352471',
  agentforceScrt2Url: 'https://spins--uat.sandbox.my.salesforce-scrt.com',
  reportIssueSiteUrl: 'https://spins--uat.sandbox.my.salesforce-sites.com',
  reportIssueFlowApiName: 'Create_Test_Case_External',
  panelDataIframeUrl: 'https://spinsllc.auth0.com/samlp/sT8Wtkhc67OUzaSvrzuHGFtHaS1fXqQH',
  attlabSfid: ['a56Dm000000LI27IAG', 'a56Dm000000LI2IIAW'],
  destiniAppsSfids: [
    'a56Dm000000LI1zIAG',
    'a56Dm000000LI2FIAW',
    'a56Dm000000LI2EIAW',
    'a56Dm000000LI2UIAW',
    'a56Dm000000LI2SIAW',
    'a56Dm000000LI2JIAW',
    'a56TH000000B7NxYAK',
  ],
  productHubSfID: 'a56Dm000000XxtOIAS',
  spinsIntelligenceSfID: 'a56TR000000ESPRYA4',
  authBaseUrl: 'https://uat.auth.spins.team',
  remoteRetailInsightsUrl: 'https://dev.retail-platform.spins.team',
  remoteBrandInsightsUrl: 'https://dev.brand-insights.spins.team',
  remoteIgnitePlusUrl: 'https://dev.ignite-plus.spins.team',
  remotePartnerInsightsUrl: 'https://spins-partner-insights-dev.uc.r.appspot.com/',
  remotePowerTabsUrl: 'https://dev.powertabs.spins.team/',
  remoteProductHubUrl: 'https://dev.ris-product-hub.spins.team',
  remoteKeyAccountApprovalsUrl: 'https://dev.key-account-approvals.spins.team',
  remoteFoundry: 'https://storage.googleapis.com/spins-foundry-dev-public-html-host/foundry-ui/',
  remoteTryFoundry: 'https://storage.googleapis.com/spins-foundry-dev-public-html-host/foundry-ui/',
  remoteInsightsBuilder:
    'https://storage.googleapis.com/spins-agentic-efficiency-dev-public-html-host/client-insights-ui/',
  remoteTraderoiUrl: 'https://dev.traderoi.spins.team/',
  remoteExtractsUrl: 'https://storage.googleapis.com/spins-extracts-dev-public-html-host/',
  keyAccountApprovalsUrl: 'http://localhost:4207',
  onMaintenance: false,
  allowedCompanyTypesDefaultFilters: ['RETAILER'],
  ignitePlusSfID: ['a56TR0000006bGDYAY', 'a56VE000000Z8vZYAS'],
  itemAttributeCodingSfID: 'a56TH0000009j2jYAA',
  disablePowerBiNavigationPane: ['a56Dm000000XxtPIAS', 'a56TH000000AXHFYA4'],
  whizAiUrl: 'https://iqvia-dev.whiz.ai/',
  whizAiAudience: 'https://spins-uat.whiz.ai/',
  auth0Domain: 'spinsllc.auth0.com',
};
